export default "__VITE_ASSET__BgQ115Z___"